import { TOAST_TIMEOUT } from 'src/config/Toast';
import store from 'src/store';
import { createToast } from 'src/store/toastsSlice';
import { type Modification } from 'src/types/modification';
import apiClient from 'src/utils/apiClient';

class ModificationService {
  /**
   * get modifications
   */
  public async getModifications() {
    const res = await apiClient.get<Modification[]>('/modifications');
    return res.data;
  }

  /**
   * create or update modification
   */
  public async createOrUpdateModifications(payload: Modification) {
    const res = await apiClient.post<Modification>('/modifications', payload);
    if (res) {
      store.dispatch(
        createToast({
          type: 'success',
          message: 'Saved modification successfully',
          timeout: TOAST_TIMEOUT,
        }),
      );
    }
    return res.data;
  }

  /**
   * delete modification
   */
  public async deleteModification(modificationId: number) {
    const res = await apiClient.delete(`/modifications/${modificationId}`);
    if (res) {
      store.dispatch(
        createToast({
          type: 'success',
          message: 'Deleted modification successfully',
          timeout: TOAST_TIMEOUT,
        }),
      );
    }
  }
}

export default new ModificationService();
